import { render } from "./Compose.vue?vue&type=template&id=ac238922&scoped=true"
import script from "./Compose.vue?vue&type=script&lang=js"
export * from "./Compose.vue?vue&type=script&lang=js"

import "./Compose.vue?vue&type=style&index=0&id=ac238922&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac238922"]])

export default __exports__